<template>
    <app-sercheable-data-table :headers="headers" :search="search" :refresh="refresh" :pagination="pagination">
        <template slot="afterReloadButton" v-if="!readonly">
            <v-btn :to="{ name: 'areaCreate' }" color="primary">{{ $t('label.createArea') }}</v-btn>
        </template>
        <template slot="items" slot-scope="{item}">
            <router-link :to="{ name: 'areaEdit', params: { id: item.id }}" tag="tr">
                <td>{{ item.office.acronym }}</td>
                <td>{{ item.acronym }}</td>
                <td>{{ item.name }}</td>
                <td class="is-active">{{ item.status }}</td>
                <td class="is-active">{{ item.outsourced }}</td>
            </router-link>
        </template>
    </app-sercheable-data-table>
</template>

<script>
import utilities from '@/helpers/utilities';
import SercheableDataTable from '../shared/SercheableDataTable';

export default {
    data() {
        return {
            pagination: {
                descending: false,
                sortBy: 'name',
            },
            headers: [
                {
                    text: this.$t('label.office'),
                    value: 'office.acronym',
                    align: 'left',
                },
                {
                    text: this.$t('label.acronym'),
                    value: 'acronym',
                    align: 'left',
                },
                {
                    text: this.$t('label.name'),
                    value: 'name',
                    align: 'left',
                },
                {
                    text: `${this.$t('label.active')}?`,
                    value: 'status',
                    align: 'left',
                },
                {
                    text: `${this.$t('label.isOutsourced')}?`,
                    value: 'outsourced',
                    align: 'left',
                },
            ],
        };
    },
    methods: {
        search(filters) {
            const areas = this.$store.getters.areas
                .filter(v => v.isActive &&
                (v.office.id === this.$store.getters.profile.office ||
                !this.$store.getters.profile.office));

            return utilities.filterMultiple(areas, filters, (area, regex) => (
                regex.test(area.office.acronym) ||
                regex.test(area.acronym) ||
                regex.test(area.name) ||
                regex.test(area.id) ||
                regex.test(area.status) ||
                regex.test(area.outsourced)
            ));
        },
        async refresh() {
            await this.$store.dispatch('loadAreas');
        },
    },
    computed: {
        areas() {
            const areas = this.$store.getters.areas;
            areas.forEach((area) => { area.status = area.isActive ? this.$t('label.yes') : this.$t('label.no'); });
            areas.forEach((area) => { area.outsourced = area.isOutsourced ? this.$t('label.yes') : this.$t('label.no'); });
            return areas;
        },
        readonly() {
            return !this.$store.getters.isAdmin;
        },
    },
    components: {
        appSercheableDataTable: SercheableDataTable,
    },
};
</script>




// WEBPACK FOOTER //
// src/components/areas/Index.vue